import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CardVariantType } from './models/card';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class AppCardComponent {
  @Input() icon: string;
  @Input() bottomTitle: string;
  @Input() description: string;
  @Input() variant?: CardVariantType = 'default';
  @Input() tagLabel?: string;
  @Input() tagVariant?: string;
  @Input() showArrow?: boolean = false;
  @Input() clickable?: boolean = false;
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  handleOnClick() {
		this.onClick.emit();
	}

  get isHighlighted() {
    return this.variant === 'highlighted';
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/components/card/card.component.ts